export const jobData = [
    {
        id: 1,
        name: "Product Management Team",
        company: "biopharmacieaa Pvt Ltd",
        category: "Product Management Team",
        type: "Full time",
        salary: "$40000-$42000",
        experience: "3 Years",
        degree: "Master",
        location: ["Pune"],
        description: [
            `We are looking for a skilled person in the product management team. As a Product Management
            Team, you will be responsible for developing and managing our product portfolio in line with the
            company’s goals and strategies. You will need to work closely with cross-functional teams such as
            sales, marketing to identify market opportunities, develop product strategies, and execute plans to
            achieve business objectives.
            About Us
            Geosmatic is a fast-growing pharmaceutical company dedicated to delivering high-quality,
            innovative, and affordable healthcare solutions. With a strong focus on dermatology, aesthetics, and
            specialty products, we strive to set new benchmarks in patient care and customer satisfaction. At
            Biopharmacieaa, we foster a culture of innovation, collaboration, and continuous learning—
            providing ambitious professionals with the right platform to build a rewarding and long-term career
            in the pharmaceutical industry.`
        ],
        responsibilities: [
            "Develop and implement product strategies to drive growth and meet business objectives.",
            "Conduct market research to identify market trends, opportunities, and potential risks.",
            "Identify new product development opportunities and ensure timely launch of new products.",
            "Develop marketing plans, promotional campaigns, and product positioning strategies.",
            "Conduct regular market analysis and competitor benchmarking to identify gaps and opportunities in the market.",
            "Manage the product life cycle from concept to launch to end-of-life, including pricing, inventory management, and profitability analysis.",
            "Train and support sales teams on product features, benefits, and competitive positioning.",
            "Work with cross-functional teams to ensure timely delivery of products and services.",
            "Monitor and report on product performance metrics, including sales revenue, profitability, and market share."
        ],
        requirements: [
            "Bachelor's or Master's degree in Pharmacy, Science, or related field.",
            "Strong understanding of product lifecycle management.",
            "Ability to collaborate with cross-functional teams.",
            "Excellent communication and analytical skills.",
            "Strong organizational and multitasking skills."
        ],
        skills: [
            "Project Management",
            "Communication",
            "Analytical Thinking",
            "Leadership"
        ],
        tags: ["Product", "Management", "Full time", "Pune"]
    },
    {
        id: 2,
        name: "Medical Representative",
        company: "biopharmacieaa Pvt Ltd",
        category: "Medical Representative",
        type: "Full time",
        salary: "$40000-$42000",
        experience: "2 Years",
        degree: "Bachelor",
        location: ["Mumbai", "Calicut", "Kochi", "Kollam", "Kozhikode", "Thrissur"],
        description: [
            `We are seeking a passionate and result-driven Medical Representative (MR) to join our
            dynamic sales team. In this role, you will be responsible for promoting our product porƞolio
            to doctors and chemists, while building and maintaining strong professional relationships.
            The position offers excellent career growth opportunities for self-motivated individuals who
            want to make a meaningful impact in the pharmaceutical sector.`
        ],
        responsibilities: [
            "Visit doctors and hospitals regularly.",
            "Promote new products.",
            "Provide product training.",
            "Maintain sales records.",
            "Promote and sell biopharmacieaa products to doctors, pharmacists, and healthcare professionals.",
            "  Build and maintain strong relationships with healthcare providers to ensure consistent product prescriptions.",
            "Achieve monthly, quarterly, and annual sales targets as assigned by the company.",
            "  Conduct product detailing, presentations, and demonstrations to highlight product benefits and advantages.",
            "IdenƟfy new business opportunities and expand market coverage within the assigned territory.",
            "Ensure product availability at chemists and distributors.",
            "Gather and report market intelligence, competitor activities, and customer feedback to management.",
            " Maintain accurate records of calls, prescripƟons generated, and daily activities.",
            " Participate actively in company meetings, training programs, and marketing initiatives."

        ],
        requirements: [
            "Bachelor’s degree in Pharmacy / Science.",
            "0–2 years of experience in pharmaceuƟcal sales.",
            "Target-driven, self-motivated, and capable of working independently.",
            "Excellent communication and analytical skills.",
            "Willingness to travel extensively within the assigned territory."
        ],
        skills: [
            "Project Management",
            "Communication",
            "Analytical Thinking",
            "Leadership"
        ],
        tags: ["Medical", "Representative", "Full time", "Mumbai"]
    },
    {
        id: 3,
        name: "Area Sales Executive",
        company: "biopharmacieaa Pvt Ltd",
        category: "Sales",
        type: "Full time",
        salary: "$40000-$42000",
        experience: "4 Years",
        degree: "Bachelor",
        location: ["Pune", "Chennai", "Guwahati", "Hubballi", "Indore", "Kerala", "Kolkata", "Mangaluru", "Mumbai", "Nagpur", "Nashik", "Sambhaji Nagar"],
        description: [
            "Responsible for achieving sales targets in assigned territory.",
            "Coordinate with distribution channels and clients."
        ],
        responsibilities: [
            "Identify new clients and business opportunities.",
            "Manage sales reports and analytics.",
            "Ensure customer satisfaction.",
            "Conduct market research."
        ],
        requirements: [
            "Education: : D.Pharm/B.Pharm / M.Pharm,",
            "Experience: :0-3 years of experience in pharma industry.",

        ],
        skills: [
            "Communication skills: They require excellent communication skills to explain and educate about the product .",
            "Knowledge – They must have good knowledge of Pharma industry",
            "Organisational skills: Professionals should be able to efficiently organise themselves according to the changing working environment. They should plan their meetings, deadlines, and schedules.",
            "Compliance and Ethics: Ensure compliance with all regulatory, legal, and company policies and procedures in all interactions with healthcare professionals.Adhere to ethical sales practices and maintain a high level of professionalism."
        ],
        tags: ["Sales", "Executive", "Full time", "Pune"]
    },
    {
        id: 4,
        name: "Regional Sales Manager",
        company: "biopharmacieaa Pvt Ltd",
        category: "Sales",
        type: "Full time",
        salary: "$40000-$42000",
        experience: "5 Years",
        degree: "Master",
        location: ["Pune", "Bangalore", "Gujarat", "Hyderabad", "Kolhapur", "Mumbai"],
        description: [
            "Lead regional sales team to achieve targets and expand business.",
            "Develop strategies for new market penetration."
        ],
        responsibilities: [
            "Customer Profiling and product positioning.",
            "Ensure coverage and customer visit on regular basis.",
            "Manage region and individual performances.",
            "Develop and implement sales strategies to increase revenue and market share.",
            "Identify new business opportunities and develop plans to pursue them.",
            "Analyze market trends and competitor activities to stay informed and adjust strategies as needed.",
            "Provide regular reports on sales performance and market trends to senior management.",
            "Collaborate with marketing and product development teams to ensure alignment on product positioning and messaging",
        ],
        requirements: [
            "Bachelor’s degree in Pharmacy / Science.",
            "Minimum of 1-3 years of experience in sales management in the derma industry.",
            "Proven track record of achieving sales targets and driving revenue growth.",
            "Strong leadership and team management skills.",
            "Excellent English communication, negotiation, and interpersonal skills",
            "Willingness to travel as needed to meet with clients and attend industry events.",
        ],
        skills: [
            "Leadership",
            "Sales Strategy",
            "Team Management",
            "Analytical Skills"
        ],
        tags: ["Sales", "Manager", "Full time", "Pune"]
    }
];
